import React from 'react';
import { Loading, MessageDialog, Toaster } from 'scbk-ui-web';
import useGlobalComponentsStore from './stores/useGlobalComponentsStore';
import { usePopupStore } from './stores/usePopupStore';

const GlobalComponents: React.FC = () => {
  const store = useGlobalComponentsStore();
  const popupStore = usePopupStore();
  const isLoading = store.isLoading;
  const pendingDialog = store.pendingActionDialogs[0];
  const popup = popupStore.get(pendingDialog?.tag ?? '');
  const dialogOpen = popup?.visible ?? false;

  /**
   *
   * @param state
   */
  const handleOpenChange: React.Dispatch<React.SetStateAction<boolean>> = (state) => {
    if (!state) {
      if (!pendingDialog.autoDismiss) {
        store.popDialog();
        popupStore.clear(pendingDialog.tag ?? '');
      }
    }
  };

  /**
   * Content 내용이 String 배열일 경우 렌더링 처리
   * @param content
   * @returns
   */
  const renderContent = (content?: string | string[] | React.ReactNode): React.ReactNode => {
    if (!content) return null;

    if (typeof content === 'string') {
      return content
        .split(/<br\s*\/?>/i)
        .filter((line) => line.trim() !== '')
        .map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index < arr.length - 1 && <br />}
          </React.Fragment>
        ));
    }

    if (Array.isArray(content)) {
      return content
        .filter((line) => line.trim() !== '')
        .map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index < arr.length - 1 && <br />}
          </React.Fragment>
        ));
    }

    return content;
  };

  return (
    <>
      <Loading loading={isLoading} type="shift" />
      {pendingDialog && (
        <MessageDialog
          type={pendingDialog.type}
          title={pendingDialog.title}
          open={dialogOpen}
          openChange={handleOpenChange}
          okBtnLabel={pendingDialog.okBtnLabel}
          cancelBtnLabel={pendingDialog.cancelBtnLabel}
          onConfirm={() => {
            const action = pendingDialog.actions.find((item) => item.type === 'confirm');
            if (!action) {
              return;
            }

            if (pendingDialog.autoDismiss) {
              store.popDialog();
              //popupStore.clear(pendingDialog.tag ?? '');
              popupStore.close(pendingDialog.tag ?? '');

              // 클릭 후 웹뷰 호출 시 팝업이 남는 문제가 발생하여 requestAnimationFrame 처리
              requestAnimationFrame(() => {
                action.onClick?.();
              });

              return;
            }

            action.onClick?.();
          }}
          onCancel={() => {
            const action = pendingDialog.actions.find((item) => item.type === 'cancel');
            if (!action) {
              return;
            }

            if (pendingDialog.autoDismiss) {
              store.popDialog();
              //popupStore.clear(pendingDialog.tag ?? '');
              popupStore.close(pendingDialog.tag ?? '');

              // 클릭 후 웹뷰 호출 시 팝업이 남는 문제가 발생하여 requestAnimationFrame 처리
              requestAnimationFrame(() => {
                action.onClick?.();
              });

              return;
            }

            action.onClick?.();
          }}
          errCode={pendingDialog.errCode}
          guideDesc={renderContent(pendingDialog.guideDesc)}
        >
          <>{renderContent(pendingDialog.content)}</>
        </MessageDialog>
      )}
      {/* 토스트 컴포넌트 */}
      <Toaster />
    </>
  );
};

export default GlobalComponents;
